import { render, staticRenderFns } from "./metatraderAccountDetail.vue?vue&type=template&id=8e9a9bc6&scoped=true"
import script from "./metatraderAccountDetail.vue?vue&type=script&lang=js"
export * from "./metatraderAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./metatraderAccountDetail.vue?vue&type=style&index=0&id=8e9a9bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9a9bc6",
  null
  
)

export default component.exports